module.exports = __webpack_public_path__ + "media/images/games/fifa-23/logo-fd5720e33f9452b783e7cbfd918bc6a9.png";